<div class="absolute inset-0 flex flex-col p-3 sm:p-4 lg:p-6 gap-3">
  <!-- Header row: title + compact stats -->
  <div class="flex items-center justify-between gap-3">
    <h1 class="text-xl sm:text-2xl xl:text-3xl font-bold tracking-tight text-gray-900">Arbeitszeiten</h1>
    <div class="flex items-center gap-2 text-sm">
      <span class="rounded-full bg-gray-100 px-3 py-1 font-medium text-gray-600">
        {{ filtered.length }} Schichten
      </span>
      <span class="rounded-full bg-theme-primary-50 px-3 py-1 font-semibold text-theme-primary-700">
        {{ hours | number: "1.0-2" }} h
      </span>
    </div>
  </div>

  <!-- Filters (compact) -->
  <div class="bg-white rounded-lg border border-gray-100 shadow-sm p-3 flex flex-col gap-3" data-testid="shift-filter-card">
    <!-- quick select: single horizontally-scrollable row on small screens -->
    <div class="flex gap-2 overflow-x-auto -mx-1 px-1 pb-0.5 scrollbar-hide">
      @for (preset of presets; track preset.id) {
        <button type="button" (click)="quickSelect(preset.id)" [attr.aria-pressed]="activePreset === preset.id"
                class="shrink-0 rounded-full px-3 py-1.5 text-sm font-medium transition-colors motion-reduce:transition-none"
                [class.bg-theme-primary-600]="activePreset === preset.id"
                [class.text-white]="activePreset === preset.id"
                [class.bg-gray-100]="activePreset !== preset.id"
                [class.text-gray-600]="activePreset !== preset.id"
                [class.hover:bg-gray-200]="activePreset !== preset.id">
          {{ preset.label }}
        </button>
      }
    </div>

    <!-- Von/Bis: calendar days in the COMPANY's time zone (a shift counts on the day its event starts, #645).
         Native date inputs overflowed this two-column grid on iOS Safari (#646): a grid item defaults to
         min-width auto, and WebKit sizes the native control from its own intrinsic width, ignoring w-full.
         min-w-0 lets the item shrink, appearance-none drops the native sizing, h-10 keeps an EMPTY input from
         collapsing, and the value is left-aligned like every other input.
         Pattern: "Date input in a grid" in docs/articles/frontend/style-guide.md. -->
    <div class="grid grid-cols-2 gap-2 sm:gap-3" data-testid="shift-range">
      <div class="min-w-0">
        <label class="block text-xs font-medium text-gray-500 mb-1" for="shift-range-from">Von</label>
        <input type="date" id="shift-range-from" name="shift-range-from" data-testid="shift-range-from"
               [ngModel]="from" (ngModelChange)="from = $event; onRangeChanged()"
               class="block h-10 w-full min-w-0 max-w-full appearance-none px-3 py-2 rounded-lg border border-gray-200 bg-white text-left text-sm text-gray-900 shadow-sm focus:border-theme-primary-500 focus:ring-1 focus:ring-theme-primary-500 [&::-webkit-date-and-time-value]:text-left">
      </div>
      <div class="min-w-0">
        <label class="block text-xs font-medium text-gray-500 mb-1" for="shift-range-to">Bis</label>
        <input type="date" id="shift-range-to" name="shift-range-to" data-testid="shift-range-to"
               [ngModel]="to" (ngModelChange)="to = $event; onRangeChanged()"
               class="block h-10 w-full min-w-0 max-w-full appearance-none px-3 py-2 rounded-lg border border-gray-200 bg-white text-left text-sm text-gray-900 shadow-sm focus:border-theme-primary-500 focus:ring-1 focus:ring-theme-primary-500 [&::-webkit-date-and-time-value]:text-left">
      </div>
    </div>

    <!-- search + department -->
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3">
      <input type="text" [ngModel]="search" (ngModelChange)="search = $event; filter()"
             aria-label="Schichten durchsuchen" placeholder="Event, Standort oder Bereich…"
             class="block w-full px-3 py-2 rounded-lg border border-gray-200 bg-white shadow-sm focus:border-theme-primary-500 focus:ring-1 focus:ring-theme-primary-500 text-sm placeholder-gray-300">
      <ng-select class="ng-select cheqme-style" [ngModel]="shardFilter" (ngModelChange)="shardFilter = $event; filter()"
                 ariaLabel="Bereich" placeholder="Alle Bereiche">
        @for (s of shards; track s) {
          <ng-option [value]="s">{{ s }}</ng-option>
        }
      </ng-select>
    </div>

    @if (hasActiveFilters) {
      <div class="flex justify-end">
        <button type="button" (click)="resetFilters()"
                class="text-sm font-medium text-theme-primary-700 hover:text-theme-primary-900">
          Filter zurücksetzen
        </button>
      </div>
    }
  </div>

  <!-- Shift list -->
  <div class="flex-1 min-h-0 bg-white rounded-lg border border-gray-100 shadow-sm overflow-hidden">
    <!--
      #748: `tabindex="0"` + a name, the same remedy the event-summary card's scroll area carries.
      A scrollable region whose rows are not themselves focusable — `ep-next-shift-item` renders no link
      and no button — cannot be reached or scrolled by keyboard at all, which axe reports as
      `scrollable-region-focusable`. `0` rather than `-1` because this list IS a tab stop: it is a plain
      page region, not the inside of a panel that closes on focusout (see the anchored-panel case, where
      a `0` here would steal focus on mousedown and close the panel under the pointer).

      The outline is `focus-visible`, so a mouse user never sees it and a keyboard user always does.
    -->
    <div tabindex="0" aria-label="Schichtliste" data-testid="shift-list"
         class="overflow-y-auto h-full divide-y divide-gray-100
                focus-visible:outline focus-visible:-outline-offset-2 focus-visible:outline-2
                focus-visible:outline-theme-primary-500">
      @for (shift of filtered; track shift.id) {
        <ep-next-shift-item [wide]="true" [shift]="shift" class="block px-4 py-3"></ep-next-shift-item>
      } @empty {
        <p class="text-sm text-gray-500 text-center py-10">Keine Schichten gefunden.</p>
      }
    </div>
  </div>
</div>
